import { useSelector, useDispatch } from 'react-redux';
import {
	ownshipIDSelector,
	setOwnshipID,
	showAircraftInfoListSelector
} from 'reducers/liveTrafficSlice';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import { canBeOwnship } from 'components/airSpace/airspaceUtils';

const OwnshipCell = ({ params }) => {
	const dispatch = useDispatch();
	const ownshipID = useSelector(ownshipIDSelector);
	const showAircraftInfoList = useSelector(showAircraftInfoListSelector);
	const isOwnship = ownshipID === params.id;

	const handleUnpin = () => {
		dispatch(setOwnshipID(null));
	};

	const handlePin = () => {
		dispatch(setOwnshipID(params.id));
	};

	if (showAircraftInfoList.includes(params.id) || (ownshipID !== null && ownshipID !== params.id)) {
		return null;
	}
	if (canBeOwnship(params.object_type)) {
		return isOwnship ? (
			<PushPinIcon onClick={handleUnpin} sx={{ cursor: 'pointer' }} />
		) : (
			<PushPinOutlinedIcon onClick={handlePin} sx={{ cursor: 'pointer' }} />
		);
	}

	return null;
};

export default OwnshipCell;
